import { ReactNode } from 'react';

import { Dialog, IDialogProps } from 'uiKit/Dialog';

import { useReferralFlowDialogStyles } from './useReferralFlowDialogStyles';

export interface IReferralFlowDialogProps
  extends Omit<IDialogProps, 'onClose'> {
  cover: string;
  onClose: () => void;
  title?: ReactNode;
}

export const ReferralFlowDialog = ({
  children,
  cover,
  title: externalTitle,
  ...dialogProps
}: IReferralFlowDialogProps) => {
  const { classes } = useReferralFlowDialogStyles();

  const title =
    externalTitle ||
    (cover && (
      <img alt="Top cover" className={classes.cover} src={cover} width="100%" />
    ));

  return (
    <Dialog
      {...dialogProps}
      classes={classes}
      closeButtonClassName={classes.closeButton}
      title={title}
      titleClassName={classes.dialogTitle}
    >
      <div className={classes.content}>{children}</div>
    </Dialog>
  );
};
